import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { WHY_BHIWANI } from "../../config/site";
import { Factory, FlaskConical, Wheat, TrainFront } from "lucide-react";

const ICONS = [Factory, FlaskConical, Wheat, TrainFront];

export const WhyBhiwani = () => (
  <Section
    id="why-bhiwani"
    overline="Why Bhiwani"
    title="A city that has traded for 200 years"
    sub="Bhiwani's industrial land is exhausted and its entrepreneurial energy is not. BIDC is where that energy moves next."
  >
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {WHY_BHIWANI.map((w, i) => {
        const Icon = ICONS[i];
        return (
          <Reveal key={w.title} delay={i * 0.08}>
            <div
              className="h-full border border-border bg-paper-light p-6 transition-transform duration-200 hover:-translate-y-1"
              data-testid={`why-bhiwani-${i}`}
            >
              <Icon className="h-7 w-7 text-gold" strokeWidth={1.5} />
              <h3 className="mt-4 font-display text-xl font-medium text-forest">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A4C4A]">{w.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </Section>
);
